export function fetchAPINames() {
  console.log("in fetchAPINames");
  console.log("url is " + process.env.REACT_APP_HOST_API_URL);
  return fetch(
    process.env.REACT_APP_HOST_API_URL +
      "/developer/mvc/api/contentFetcher/apiNames?path=managemyaccount/firstnet/myapis",
    {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    }
  )
    .then(response => 	response.json())
    .catch(error => {
      console.log("error trying to fetch api names : \n", error);
      return Promise.reject();
    });
}



// WEBPACK FOOTER //
// ./src/manageMyAccount/api/APINamesFetcher.js